<template>
  <div v-if="card" transition="modal" class="backdrop" v-on:click="dismissModal" ref="stacks">

    <form class="edit-card-form" v-on:submit.prevent="update" v-on:click.stop="">
      <h3>Found in {{card.stackCount}} stack(s)</h3> 
      <div v-for="stack in stacks">

        <div v-if="user">
          <div v-if="stack.key != card.boundStack">
            <p><a :href="'stacks/'+stack.slug">{{stack.title}}</a>
              <span v-if="stack.cards">
                <span v-if="stack.cards.hasOwnProperty(card.key)">
                  added
                  <a href="javascript:void(0)" @click="removeStack(card, stack)">remove</a>
                </span>
                <span v-else><a href="javascript:void(0)" @click="addStack(card, stack)">add</a></span>
              </span>
              <span v-else><a href="javascript:void(0)" @click="addStack(card, stack)">add</a></span>
            </p>
          </div>
        </div>

        <div v-else>
          <span v-if="stack.cards.hasOwnProperty(card.key)">
            <p><a :href="'/stack/'+stack.slug">{{stack.title}}</a></p>
          </span>
        </div>

      </div>
      <button type="submit">Done</button>
    </form>

  </div>
</template>

<script>
  import stackFunctions from '../../data/stackFunctions'
  import cardRepository from '../../data/CardRepository'
  import EventBus from '../EventBus'

  export default {
    data() {
      return {
        card: null,
        stack: null,
        stacks: []
      }
    },
    props: ['user'],
    computed: {

    },
    created: function () {
      EventBus.$on('card.stack', this.selectCard)
      EventBus.$on('stack.addStack', this.selectStack)
    },
    beforeDestroy: function () {
      EventBus.$off('card.stack', this.selectCard)
      EventBus.$off('stack.addStack', this.selectStack)
    },
    methods: {
      addStack: function(card, stack){

        var order

        if(stack.cards) {
          order = stack.cardCount + 1
        } else {
          order = 1
        }

        cardRepository.addStack(card, stack, order, (err) => {
          if (err) throw err
        });
      },
      removeStack: function(card, stack){

        cardRepository.removeStack(card, stack, (err) => {
          if (err) throw err
        });

        // stackFunctions.removeCard(stack, card.key, (err) => {
        //   if(err) throw err
        // });
      },
      selectCard: function(card){
        this.card = card   
        
      },

      selectStack: function(stack){
        this.card = stack.boundCardObj
        this.card.key = stack.boundCard
        
      },

      update () {
        this.dismissModal()

      },
      dismissModal () {
        this.card = null
      }
    },
    
    mounted() {
      stackFunctions.on('added', (stack) => {
        this.stacks.unshift(stack) // add the card to the beginning of the array

      })

      stackFunctions.on('changed', ({key, title, description, slug, cards, cardCount}) => {
          let outdatedStack = stackFunctions.find(this.stacks, key) // get specific note from the notes in our VM by key
          outdatedStack.title = title
          outdatedStack.description = description
          outdatedStack.slug = slug
          outdatedStack.cards = cards
          outdatedStack.cardCount = cardCount
      })

      stackFunctions.on('removed', ({key, cards}) => {
          let stackToRemoveCard = stackFunctions.find(this.stacks, key) // get specific note from the notes in our VM by key
          stackToRemoveCard.cards = cards
      })

      stackFunctions.attachFirebaseListeners()
    },
    beforeDestroy() {
      stackFunctions.detachFirebaseListeners()
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// StackModal.vue?11a0dbb8